import React from "react";
import { useLang } from "@/context/LanguageContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { PawIcon } from "@/components/Icons";
import Reveal from "@/components/Reveal";

const FAQ = () => {
  const { t } = useLang();
  return (
    <section id="faq" className="py-20 sm:py-28" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center mb-12">
          <span className="font-script text-3xl text-[#f4956a] inline-flex items-center gap-2">
            <PawIcon size={22} /> FAQ
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2">{t.faq.title}</h2>
          <p className="text-[#6b3f2a]/75 mt-4 text-sm sm:text-base">{t.faq.subtitle}</p>
        </Reveal>

        <Reveal>
          <Accordion type="single" collapsible className="space-y-3">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white border border-[#fbe1de] rounded-2xl px-5 shadow-sm"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display text-base sm:text-lg text-[#6b3f2a] hover:no-underline py-5">
                  <span className="flex items-center gap-3">
                    <span className="w-7 h-7 rounded-full bg-[#fdf3ec] flex items-center justify-center text-[#f4956a] shrink-0">
                      <PawIcon size={14} />
                    </span>
                    {item.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[#6b3f2a]/85 text-sm sm:text-base leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
